// internal imports
import Service from 'core/decorators/Service';
import ConfigUtil from 'core/util/config/ConfigUtil';
import TokenSession from 'core/util/session/TokenSession';
import StringUtil from 'core/util/StringUtil';
import IResolverService, { CachingPolicy, QueryFunction } from '../IResolverService';

/**
 * @overview: An {@link IQueryResolver} using fetch()
 * @author: jesposito
 */

@Service()
export default class FetchResolverService extends IResolverService {
	private static NAME: string = "fetch";

	private fetchOptions: RequestInit;
	private uri: string; // service uri

	constructor() {
		super();

		// get the authentication token from local storage if it exists
		const token = TokenSession.getToken();

		this.fetchOptions = {
			method: 'post',
			headers: new Headers({
				'Authorization': `Bearer ${token}`,
				'Content-Type': 'application/json'
			}),
		};

		this.uri = ConfigUtil.getEnvConfig().graphqlUri;
	}

	public execute(query: string | QueryFunction, params?: object): Promise<any> {
		const q = typeof query === "string" ? query : query(params);

		// set our post body as the query string
		const options = {
			...this.fetchOptions,
			body: JSON.stringify({ query: q })
		};

		// return the promise
		return FetchResolverService.validateResponse(fetch(this.uri, options));
	}

	public getServiceId(): string {
		return FetchResolverService.NAME;
	}

	/*public getConditions() {
		return {fetchPolicy: CachingPolicy.NONE};
	}*/

	public clearCache() { return Promise.resolve(); }
}




// WEBPACK FOOTER //
// ./src/core/service/resolver/impl/FetchResolver.service.ts